function addMessage(message, messageType) {
    return dispatch => {
        dispatch({
            type: "addMessage",
            message,
            messageType
        });
    };
}

function deleteMessage() {
    return dispatch => {
        dispatch({
            type: "deleteMessage"
        });
    };
}

export {
    addMessage,
    deleteMessage
};


// WEBPACK FOOTER //
// ./src/Actions/messages.js